import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { ContentService } from '../../../services/content.service';

@Component({
  selector: 'app-team-profile-strengths',
  templateUrl: './team-profile-strengths.component.html',
  styleUrls: ['./team-profile-strengths.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class TeamProfileStrengthsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.contentService.getReport('TeamsTeamStrengths', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
